import { BaseService } from '@adgate/common/services/base-service';
import { Service } from '@angular/core';
import { environment } from '@env/environment';

@Service()
export class DashboardService extends BaseService
{
    private baseServiceUrl = `${environment.baseServiceUrl}dashboard`;

    getStatsByStatus(officeId: number | null, agencyId: number | null)
    {
        let parameters = '';
        parameters += (officeId != null ? `?officeId=${officeId}` : '');
        parameters += (agencyId != null ? (parameters !== '' ? `?agencyId=${agencyId}` : `&agencyId=${agencyId}`) : '');

        let url = `${this.baseServiceUrl}/getStatsByStatus${parameters}`;
        return this.sendRequest(url, null, 'get');
    }

    getUrgentItems(officeId: number | null, agencyId: number | null)
    {
        let parameters = '';
        parameters += (officeId != null ? `?officeId=${officeId}` : '');
        parameters += (agencyId != null ? (parameters !== '' ? `?agencyId=${agencyId}` : `&agencyId=${agencyId}`) : '');

        let url = `${this.baseServiceUrl}/getUrgentItems${parameters}`;
        return this.sendRequest(url, null, 'get');
    }

    getRecentActivity(officeId: number | null, agencyId: number | null)
    {
        let parameters = '';
        parameters += (officeId != null ? `?officeId=${officeId}` : '');
        parameters += (agencyId != null ? (parameters !== '' ? `?agencyId=${agencyId}` : `&agencyId=${agencyId}`) : '');

        let url = `${this.baseServiceUrl}/getRecentActivity${parameters}`;
        return this.sendRequest(url, null, 'get');
    }
}
